import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';

const DATA_FOCUS_ATTR = 'header-user-details';

export class HeaderUserDetails extends Component {
  handleOpenDropdown = () => {
    const { dropdownOpen, mediaQueryLg, onDropdownStateToggled } = this.props;
    if (mediaQueryLg && !dropdownOpen) {
      onDropdownStateToggled();
    }
  };

  handleCloseDropdown = () => {
    const { dropdownOpen, mediaQueryLg, onDropdownStateToggled } = this.props;
    if (mediaQueryLg && dropdownOpen) {
      onDropdownStateToggled();
    }
  };

  /**
   * We check if the focused element is not in the component since we want to close the dropdown if
   * we have tabbed through all the options of the component.
   */
  handleBlur = evt => {
    const { dropdownOpen, onDropdownStateToggled, mediaQueryLg } = this.props;

    // 'relatedTarget' contains the element that gains focus. If the component is in focus
    // but the user clicks outside of the component on an unfocusable elment (ex. 'div'),
    // 'relatedTarget' will be 'null'.
    const isElemNotInComponent = !evt.relatedTarget?.closest(`div[data-container="${DATA_FOCUS_ATTR}"]`);
    if (mediaQueryLg && isElemNotInComponent && dropdownOpen) {
      onDropdownStateToggled();
    }
  };

  render() {
    const { dropdownOpen, mediaQueryLg, avatarUrl, firstName, children, onDropdownStateToggled } = this.props;

    return (
      <div
        className="header__dropdown"
        data-container={DATA_FOCUS_ATTR}
        onBlur={this.handleBlur}
        onMouseEnter={this.handleOpenDropdown}
        onMouseLeave={this.handleCloseDropdown}>
        <button
          aria-controls="header-dropdown-profile"
          aria-expanded={dropdownOpen}
          className={classNames('header__dropdown__target', {
            'header__dropdown__target--open': dropdownOpen,
          })}
          data-qa="header-user-details-btn"
          onClick={onDropdownStateToggled}>
          <div className="header__dropdown__avatar">
            {avatarUrl ? <img src={avatarUrl} alt="user avatar" /> : <span>{(firstName || '').slice(0, 1)}</span>}
          </div>
          <Isvg className="header__dropdown__arrow svg" uniquifyIDs={false} src={require('static/img/arrow.svg')} />
        </button>
        {dropdownOpen && mediaQueryLg && children && (
          <div className="header__dropdown__panel" id="header-dropdown-profile">
            {children}
          </div>
        )}
      </div>
    );
  }
}

HeaderUserDetails.propTypes = {
  avatarUrl: PropTypes.string,
  children: PropTypes.node,
  dropdownOpen: PropTypes.bool,
  firstName: PropTypes.string,
  mediaQueryLg: PropTypes.bool,
  onDropdownStateToggled: PropTypes.func.isRequired,
};
